export default __webpack_public_path__ + "static/media/Cryptocurrency-Dental-NFT-Coin-Tokens-1-1200x500.a9774832.jpg";